module.exports = __webpack_public_path__ + "static/media/speech_14.dd1a89cc.svg";